import { connect } from 'react-redux';
import {
  getMessages,
  getMessagesFilter,
  getMessageTypeFilter,
  getMessageXml,
  resetMessages
} from '../../../store/actions/adminMessages';
import MessagesAdmin from './MessagesAdmin';

const mapStateToProps = ({
  adminMessagesReducer,
  tabsReducer
}) => ({
  adminMessagesReducer,
  tabsReducer
});
const mapDispatchToProps = {
  getMessages,
  getMessagesFilter,
  getMessageTypeFilter,
  getMessageXml,
  resetMessages
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessagesAdmin);
